import React, { useState } from "react";
import SuggestionHistorique from "./SuggestionHistorique";

export function EditSuggestionForm({ fiche, onCancel, onSave }) {
    const [form, setForm] = useState({
        sugTerme: fiche.sugTerme,
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(fiche.sugId, form); // ✅ maintenant défini
    };

    return (
        <form onSubmit={handleSubmit} className="p-3 border rounded">

            <div className="pb-3" style={{color:"white"}}>
                <div className="row">
                    <label className="form-label"><strong>Terme</strong></label>
                    <input
                        name="sugTerme"
                        value={form?.sugTerme}
                        onChange={handleChange}
                        className="form-control"
                    />
                </div>
                <div className="row pt-2 pb-2">
                    <div className="col-6"><strong>Collège :</strong> {fiche?.sugDom?.commissions[0].comLib}</div>
                    <div className="col-6"><strong>Date suggestion :</strong> {new Date(fiche.sugDate).toLocaleDateString("fr-FR")}</div>
                </div>
                <div className="row pb-2">
                    <div className="col-6"><strong>Domaine suggéré :</strong> {fiche?.sugDom?.domLib}</div>
                    <div className="col-6"><strong>Domaine (*):</strong> {fiche?.sugDom?.domLib}</div>
                </div>

                <div className="row">
                    <div className="col-6">
                        <strong>Definition :</strong>
                        <textarea
                            name="sugDefinition"
                            className="form-control"
                            onChange={handleChange}
                            defaultValue={fiche?.sugDefinition || ""}
                            style={{height: "150px"}}
                        />
                    </div>
                    <div className="col-6">
                        <strong>Commentaire :</strong>
                        <textarea
                            name="sugCommentaire"
                            onChange={handleChange}
                            className="form-control"
                            defaultValue={fiche?.sugCommentaire || ""}
                            style={{height: "150px"}}
                        /></div></div>
            </div>

            <SuggestionHistorique sugId={fiche.sugId} />

            <button type="submit" className="btn fr-btn me-2">
                Enregistrer
            </button>
            <button
                type="button"
                className="btn fr-btn btn fr-btn--secondary"
                onClick={onCancel}
            >
                Annuler
            </button>
        </form>
    );
}
